import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResourceTemplate } from '@app/interfaces/rm/resource-template';
import { ResourceTemplateService } from '@services/rm/resource-template.service';

@Component({
    selector: 'app-select-template',
    templateUrl: './select-template.component.html',
    styleUrls: ['./select-template.component.less'],
})
export class SelectTemplateComponent implements OnInit {
    @Input() type!: string;
    @Output() selectTemplate = new EventEmitter();
    selectTemplateId!: number;
    resourceTemplateOptions: ResourceTemplate[] = [];
    isLoading = false;
    page = 0;
    size = 10;
    total = 0;

    constructor(private resourceTemplateService: ResourceTemplateService,) {
    }

    ngOnInit(): void {
    }

    openChange($event: boolean): void {
        if ($event) {
            this.resourceTemplateOptions = [];
            this.loadMore(true);
        }
    }

    changeSelect(): void {
        const template = this.resourceTemplateOptions.find(item => item.id === this.selectTemplateId);
        this.selectTemplate.emit(template);
    }

    async loadMore(init: boolean = false): Promise<void> {
        try {
            if (!init && this.resourceTemplateOptions.length >= this.total) {
                return;
            }
            this.isLoading = true;
            const { content, totalElements } = await this.resourceTemplateService.find({
                page: init ? 0 : this.page + 1,
                size: this.size,
                resourceType: this.type
            });
            this.total = totalElements;
            this.resourceTemplateOptions = [...this.resourceTemplateOptions, ...content || []];
        } finally {
            this.isLoading = false;
        }
    }

}
